import React              from 'react';
import { Observe, observable } from 'rewire-core';
import {
  IEditorField,
  IToggleMenuItem
}                              from 'rewire-ui';
import ArrowDropDownIcon       from '@material-ui/icons/ArrowDropDown';
import OptionsToggleMenu       from '../ui/OptionsToggleMenu';
import { Theme, makeStyles }   from '../utility/styles';

const styles = (_theme: Theme) => ({
  fieldContainer: {
    width: '100%',
    marginBottom: '15px',
    '& > div': {
      display: 'flex',
    },
  },
  button: {
    minWidth: '100px',
    minHeight: '0px',
    padding: '5px',
    marginLeft: '15px',
    '&:first-child': {
      marginLeft: '0px',
    },
  },
});

const useStyles = makeStyles(styles);

const phoneItems: IToggleMenuItem[] = observable([
  { name: 'mobile',  title: 'Mobile',   active: false, closeOnClick: false },
  { name: 'work',    title: 'Work',     active: false, closeOnClick: false },
  { name: 'fax',     title: 'Fax',      active: false, closeOnClick: false },
  { name: 'workFax', title: 'Work Fax', active: false, closeOnClick: false },
]);

const EmployeeFieldView = (props: { field: IEditorField }): JSX.Element | null => {
  const classes       = useStyles();
  const { field }     = props;
  const buttonContent = (<>Phone options<ArrowDropDownIcon fontSize='large' /></>);

  return (
    <Observe render={() => {
      if (field.name === 'phone') {
        // insert a phone menu before the phone fields
        return (
          <>
            <div className={classes.fieldContainer}>
              <OptionsToggleMenu
                title='Phones to display'
                tooltip='Choose phones to display'
                menuId='employee-phones'
                buttonContent={buttonContent}
                buttonProps={{ disableRipple: true }}
                items={phoneItems}
                classes={{ menuButton: classes.button }}
              />
            </div>

            <div className={classes.fieldContainer}>
              <field.Editor />
            </div>
          </>
        );
      }

      const phoneItem = phoneItems.find(pi => pi.name === field.name);
      if (!phoneItem || phoneItem.active || (field.value !== undefined)) {
        // either not a phone entry or a visible phone entry or possibly an invisible phone entry that has a value
        return (
          <div className={classes.fieldContainer}>
            <field.Editor />
          </div>
        );
      }
      // phone entry not visible
      return null;
    }} />
  );
};

export default (props: { fields: IEditorField[] }): JSX.Element | null => {
  const { fields } = props;
  phoneItems;

  return <Observe render={() => {
    return (
      fields.map((field: IEditorField) => <EmployeeFieldView key={field.name} field={field} />)
    );
   }} />;
};
